import { urlParamsToFilters } from '@app/app-updates-table-filters/src/utils/urlFilterUtils';
import type {
  BundlesStateType,
  BundlesFiltersStateType,
  BundleFilterAppSelectType,
  BundleFilterDateSelectType,
  BundleFilterSearchSelectType,
  BundlesFiltersApplyType,
  BundlesFiltersResetType,
  BundlesDataLinksSetType,
  BundlesLoadingSetType,
  BundlesErrorSetType,
  BundlesCursorSetType,
  BundlesLimitSetType,
} from '../types';

type BundleAction =
  | BundleFilterAppSelectType
  | BundleFilterDateSelectType
  | BundleFilterSearchSelectType
  | BundlesFiltersApplyType
  | BundlesFiltersResetType
  | BundlesDataLinksSetType
  | BundlesLoadingSetType
  | BundlesErrorSetType
  | BundlesCursorSetType
  | BundlesLimitSetType;

const urlFilters = urlParamsToFilters();

const initialFiltersState: BundlesFiltersStateType = {
  selectedProducts: urlFilters.selectedProducts ?? null,
  selectedBundleDate: urlFilters.selectedBundleDate ?? null,
  searchQuery: urlFilters.searchQuery ?? null,
};

const emptyFiltersState: BundlesFiltersStateType = {
  selectedProducts: null,
  selectedBundleDate: null,
  searchQuery: null,
};

export const INITIAL_BUNDLES_STATE: BundlesStateType = {
  data: [],
  isLoading: false,
  error: null,
  links: { prev: null, self: '', next: null },
  pagination: {
    cursor: urlFilters.cursor,
    limit: urlFilters.limit ?? 100,
  },
  draftFilters: { ...initialFiltersState },
  committedFilters: {
    ...initialFiltersState,
    committedFiltersVersion: 0,
  },
};

export const bundlesReducer = (
  state: BundlesStateType,
  action: BundleAction,
): BundlesStateType => {
  switch (action.type) {
    case 'BUNDLE_FILTER_APP_SELECT':
      return {
        ...state,
        draftFilters: {
          ...state.draftFilters,
          selectedProducts: action.payload.selectedProducts,
        },
      };

    case 'BUNDLE_FILTER_DATE_SELECT':
      return {
        ...state,
        draftFilters: {
          ...state.draftFilters,
          selectedBundleDate: action.payload.selectedBundleDate,
        },
      };

    case 'BUNDLE_FILTER_SEARCH_SELECT':
      return {
        ...state,
        draftFilters: {
          ...state.draftFilters,
          searchQuery: action.payload.searchQuery,
        },
      };

    case 'BUNDLES_FILTERS_APPLY':
      return {
        ...state,
        committedFilters: {
          ...state.draftFilters,
          committedFiltersVersion:
            state.committedFilters.committedFiltersVersion + 1,
        },
        pagination: {
          ...state.pagination,
          cursor: undefined,
        },
      };

    case 'BUNDLES_FILTERS_RESET':
      return {
        ...state,
        draftFilters: {
          ...emptyFiltersState,
          selectedBundleDate: action.payload.selectedBundleDate,
        },
        committedFilters: {
          ...emptyFiltersState,
          selectedBundleDate: action.payload.selectedBundleDate,
          committedFiltersVersion:
            state.committedFilters.committedFiltersVersion + 1,
        },
        pagination: {
          ...state.pagination,
          cursor: undefined,
        },
      };

    case 'BUNDLES_DATA_LINKS_SET':
      return {
        ...state,
        data: action.payload.data,
        links: action.payload.links,
      };

    case 'BUNDLES_LOADING_SET':
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };

    case 'BUNDLES_ERROR_SET':
      return {
        ...state,
        error: action.payload.error,
      };

    case 'BUNDLES_CURSOR_SET':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          cursor: action.payload.cursor,
        },
      };

    case 'BUNDLES_LIMIT_SET':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          limit: action.payload.limit,
          cursor: undefined,
        },
      };

    default:
      return state;
  }
};
